/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import "./LoginEmail.css";
import { simpleFetch } from "../../restWrapper";
import { validLoginEmailDonor } from "../../assets/validators/donorInfo.js";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { resolveThemeColors } from "../../assets/helper";

class LoginEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      errMsgs: [],
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.reroute = this.reroute.bind(this);
  }

  handleChange(event) {
    this.setState({ username: event.target.value });
  }

  reroute() {
    this.setState({ loading: true });
    const validData = validLoginEmailDonor(this.state, this.props.language);
    if (!validData.isValid) {
      this.setState({
        errMsgs: validData.msgs,
        loading: false,
      });
      return false;
    }
    simpleFetch("/donors/username", "POST", {
      username: this.state.username,
    }).then((res) => {
      switch (res.status) {
        case 404:
          this.props.history.push({
            pathname: "/SignupPassword",
            state: {
              username: this.state.username,
              color: this.props.location.state.color,
              logoStyle: this.props.location.state.logoStyle,
              organizationName: this.props.location.state.organizationName,
            },
          });
          break;
        case 204:
          this.props.history.push({
            pathname: "/LoginPassword",
            state: {
              username: this.state.username,
              logoStyle: this.props.location.state.logoStyle,
              color: this.props.location.state.color,
              organizationName: this.props.location.state.organizationName,
            },
          });
          break;
        default: {
          const errorMessage = res.body?.message
          || (typeof res.body === "string" ? res.body : null)
          || "An error occurred";
          this.setState({
            errMsgs: [errorMessage],
            loading: false,
          });
          break;
        }
      }
    });
  }

  render() {
    // location.state carries the org theme/logo passed from LoginPrompt.
    // It is lost on a direct visit or page refresh, so bounce back to
    // LoginPrompt (which re-fetches that data) instead of crashing.
    if (!this.props.location.state || !this.props.location.state.color) {
      return <Redirect to="/LoginPrompt" />;
    }

    const languageObj = this.props.languageObj;
    const logoStyle = this.props.location.state.logoStyle;

    const organizationName = this.props.location.state.organizationName;

    const resolved = resolveThemeColors(
      this.props.location.state.color.headerColor,
      this.props.location.state.color.buttonColor
    );

    const originalHeaderStyle = {
      background: "#" + this.props.location.state.color.headerColor,
    };

    const backgroundOverrideStyle = {
      background: "#" + resolved.headerColor,
    };

    const textOverrideStyle = {
      color: "#" + resolved.buttonColor,
    };
    /*
    const buttonOverrideStyle = {
      background: '#' + this.props.location.state.color.headerColor,
      color: '#' + this.props.location.state.color.buttonColor
    };
*/

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this.reroute();
      }
    };

    return (
      <div className="LoginEmail-view" data-testid="loginemail-view">
        <Helmet>
          <title>{organizationName}</title>
        </Helmet>
        <div className="LoginEmail-prompt">
          <div
            className="LoginEmail-backLink"
            onClick={() =>
              window.history.length > 1
                ? this.props.history.goBack()
                : this.props.history.push("/LoginPrompt")
            }
          >
            <div className="LoginEmail-backContainer">
              <div className="LoginEmail-back">
                <div className="LoginEmail-backBtn" />
                <div className="LoginEmail-backText">{languageObj.backTxt}</div>
              </div>
            </div>
          </div>

          <div
            className="LoginEmail-logoContainer"
            style={originalHeaderStyle}
          >
            {logoStyle && (
              <div className="LoginEmail-logo" style={logoStyle}></div>
            )}
          </div>

          <div className="LoginEmail-text">{languageObj.text}</div>

          <div className="LoginEmail-inputFieldContainer">
            <div className="LoginEmail-inputContainerLeft">
              <input
                onChange={this.handleChange}
                type="text"
                className="LoginEmail-inputField"
                placeholder={languageObj.placeholder}
                onKeyDown={handleKeyDown}
                data-testid="loginemail-email-input"
              />
            </div>
            <div className="LoginEmail-inputContainerRight">
              <div
                onClick={this.reroute}
                className="LoginEmail-nextBtn"
                style={backgroundOverrideStyle}
                data-testid="loginemail-submit-btn"
              >
                {this.state.loading ? (
                  
                  <div className="LoginEmail-nextText" style={textOverrideStyle}>
                    Loading...
                  </div>
            
                ) : (
                  <div className="LoginEmail-nextText" style={textOverrideStyle}>
                    {languageObj.btn}
                  </div>
                )}
              </div>
            </div>
          </div>

          {this.state.errMsgs.map((err) => (
            <div key={err} className="LoginEmail-errorContainer">
              <div className="LoginEmail-errorIndicator"></div>
              <div className="LoginEmail-errorMessage">{err}</div>
            </div>
          ))}

          <div className="LoginEmail-chin"></div>
        </div>
      </div>
    );
  }
}

LoginEmail.propTypes = {
  login: PropTypes.func,
  languageObj: PropTypes.object,
  language: PropTypes.string,
};

export default LoginEmail;
